
const titleMap = {
  dashboad: 'Dashboard',
  indentsDetails: 'Indents',
  indents: 'Indents',
  indentCreate: 'Indent Create',
  optima: 'Optima',
  mdm: 'Data Manager',
  settings: 'Settings',
  invoices: 'Invoices',
  invoicesDetails: 'Invoice Details',
  invoicesReview: 'Invoice Review',
  user: 'Users',
  role: 'Roles',
  material: 'Materials',
  depot: 'Depots',
  depotDetails: 'Depots',
  consignees: 'Consignees',
  transporters: 'Transporters',
  bucc: 'Bucc',
  rateMatrix: 'Rate Matrix',
  detentions: 'Detentions',
};

export default function title(id) {
  return titleMap[id];
}
